export const PARTNER_FINANCING_TERM_MONTHS = 48;
export const PARTNER_FINANCING_ANNUAL_RATE = 0.10;
export const PARTNER_FINANCING_DOWN_PAYMENT_PERCENT = 0.10;

export function calculateMonthlyPayment(
  principal: number,
  termMonths: number = PARTNER_FINANCING_TERM_MONTHS,
  annualRate: number = PARTNER_FINANCING_ANNUAL_RATE,
): number {
  if (!principal || principal <= 0 || termMonths <= 0) return 0;
  const monthlyRate = annualRate / 12;
  if (monthlyRate === 0) return principal / termMonths;
  const growth = Math.pow(1 + monthlyRate, termMonths);
  return (principal * monthlyRate * growth) / (growth - 1);
}

export function calculatePartnerMonthlyPayment(fullPrice: number): number {
  if (!fullPrice || fullPrice <= 0) return 0;
  const financed = fullPrice * (1 - PARTNER_FINANCING_DOWN_PAYMENT_PERCENT);
  return calculateMonthlyPayment(financed);
}
